export default __webpack_public_path__ + "static/logo-inverted-cf652cad3dae45bd2dbdef3df43c1ffe83fbf5552b3ae6abfcc893c8dcf083eb.png";